import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
.ant-table-pagination {
   && {
    margin-right: 32px;
   }
}
`;
